module.exports = __webpack_public_path__ + "static/media/user2.e3abc641.jpeg";